import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-four',
  templateUrl: './content-four.component.html',
  styleUrls: ['./content-four.component.css']
})
export class ContentFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
